import React, { useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import SearchSelector from '../search-selector/';
import * as Actions from '../../redux/actions/';
import './feature-category-selector.scss';

const FeatureCategorySelector = ({ featureCategoryData, featureCategories, disabled, getCollectionSubscription, label, onDeselect, onSelect, onSubCategorySelect, onSubCategoryDeselect, subCategoryData }) => {
	const [isSelected, setIsSelected] = useState(featureCategoryData && featureCategoryData.name);
	const [subCategories, setSubCategories] = useState(subCategoryData|| null);
	const [subCategoryLabel, setSubCategoryLabel] = useState((featureCategoryData && featureCategoryData.categoryLabel) || null);
	const [subCategoryIsSelected, setSubCategoryIsSelected] = useState(subCategoryData && subCategoryData.name);
	const [isLoadingFeatureCategories, setIsLoadingFeatureCategories] = useState(true);
	let unsubRef = useRef(null);

	useEffect(() => {
		setIsLoadingFeatureCategories(false);
	}, [featureCategories]);

	useEffect(() => {
		if (featureCategoryData) {
			setIsSelected(true);
			if (featureCategoryData.hasSubCategories) {
				const selectedFeatureCategory = featureCategories.find((cat) => cat.id === featureCategoryData.id);
				setSubCategories(selectedFeatureCategory.subCategories.data);

				if (subCategoryData) {
					setSubCategoryIsSelected(true);
				}
			}
		}
	}, [subCategoryData, featureCategories, featureCategoryData]);

	useEffect(() => {
		setIsLoadingFeatureCategories(true);
		unsubRef.current = getCollectionSubscription('featureCategories');
		return () => {
			unsubRef.current && unsubRef.current();
		}
	}, [getCollectionSubscription]);

	const handleFeatureCategorySelect = (selection) => {
		const featureCategory = featureCategories.find(featureCategory => featureCategory.id === selection.id);
		let returnData = {id: featureCategory.id, name: featureCategory.name};
		if (!featureCategory) {
			console.log(`${selection.id} not found in featureCategories`, featureCategories);
		}
		if (selection.subCategories) {
			setSubCategoryLabel(selection.subCategories.label);
			setSubCategories(selection.subCategories.data);
			returnData.hasSubCategories = true;
		}
		onSelect(returnData);
		setIsSelected(true);
  }

	const handleFeatureCategoryDeselect = () => {
		setSubCategoryLabel(null);
		setSubCategories(null);
		setSubCategoryIsSelected(false);
		setIsSelected(false);
		onDeselect();
		onSubCategoryDeselect && onSubCategoryDeselect(null);
  }

	function handleSubCategorySelect(val) {
		onSubCategorySelect && onSubCategorySelect(val);
		setSubCategoryIsSelected(true);
	}

	function handleSubCategoryDeselect() {
		onSubCategoryDeselect && onSubCategoryDeselect(null);
		setSubCategoryIsSelected(false);
	}

	return (
		<div className="feature-categories-selector">
		{ disabled ? (
				<div className="form-element disabled">
				<h2>Type:</h2>
				<div className="input-wrap">
					<div className="dead-input">{featureCategoryData && featureCategoryData.name}</div>
				</div>
				{featureCategoryData && featureCategoryData.subCategory &&
					<>
						<h2>Category:</h2>
						<div className="input-wrap">
							<div className="dead-input">{featureCategoryData.subCategory.name}</div>
						</div>
					</>
				}
			</div>
		) :
			<>
				<SearchSelector
					items={featureCategories}
					fieldIdentifier="Feature Type"
					label={label}
					onSelect={handleFeatureCategorySelect}
					onDeselect={handleFeatureCategoryDeselect}
					assistiveText={{}}
					isLoading={isLoadingFeatureCategories}
					isSelected={isSelected}
					loadingText="Loading Feature Types..."
					searchingText="Searching Feature Types..."
					value={featureCategoryData}
					disabled={disabled}
					disableSearch
				/>
				{subCategories &&
					<SearchSelector
						items={subCategories}
						fieldIdentifier="Category"
						label={subCategoryLabel}
						onSelect={handleSubCategorySelect}
						onDeselect={handleSubCategoryDeselect}
						assistiveText={{}}
						isSelected={subCategoryIsSelected}
						loadingText="Loading Feature Categories..."
						searchingText="Searching Feature Categories..."
						value={subCategoryData}
						disabled={disabled}
						disableSearch
					/>
				}
			</>
		}
		</div>
	)
};

FeatureCategorySelector.propTypes = {
	featureCategories: PropTypes.array,
	disabled: PropTypes.bool,
	label: PropTypes.string,
	getCollectionSubscription: PropTypes.func,
	onSelect: PropTypes.func
}


const mapStateToProps = state => {
  return {
		featureCategories: state.featureCategories
	}
}

const mapDispatchToProps = {
	getCollectionSubscription: Actions.getCollectionSubscription
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(FeatureCategorySelector)
